// extracted by mini-css-extract-plugin
export default {"img":"About_img__9aaDm","description":"About_description__a21Ro","contentBox":"About_contentBox__7Tl4t","content":"About_content__ATm5f","title":"About_title__n4y64"};